import { Button } from "./ui/button.tsx";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card.tsx";
import { Check, Globe } from "lucide-react";
import { useState, useEffect } from "react";
import { detectUserLocation } from "./lib/utils.ts";

const PricingSection = () => {
  const [currency, setCurrency] = useState('CHF');
  const [countryName, setCountryName] = useState('Schweiz');
  const [isLoading, setIsLoading] = useState(true);

  // Pricing configuration
  const pricing = {
    CHF: {
      symbol: 'CHF',
      amount: '9.90',
      name: 'Schweizer Franken'
    },
    EUR: {
      symbol: '€',
      amount: '9.90',
      name: 'Euro'
    }
  };

  // Detect user's location and set appropriate currency
  useEffect(() => {
    const detectLocation = async () => {
      try {
        const locationData = await detectUserLocation();
        setCurrency(locationData.currency);
        setCountryName(locationData.countryName);
        

      } catch (error) {
        console.log('Location detection failed, using default:', error);
        setCurrency('CHF');
        setCountryName('Schweiz');
      } finally {
        setIsLoading(false);
      }
    };

    detectLocation();
  }, []);

  const features = [
    "Tägliche WhatsApp- oder SMS-Nachricht",
    "Automatische Benachrichtigung bei fehlender Antwort",
    "14 Tage kostenlos testen, danach CHF 9.90 im Monat. Keine Kreditkarte nötig.",
    "Jederzeit kündbar"
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Ihr Vorteil
        </h2>
        <p className="text-xl text-gray-600 mb-12">
          Transparent, fair und risikofrei
        </p>
        
        <Card className="max-w-md mx-auto border-2 border-blue-600 shadow-xl">
          <CardHeader className="bg-blue-600 text-white text-center rounded-t-lg">
            <CardTitle className="text-2xl">Es geht mir gut</CardTitle>
            
            {/* Location indicator */}
            <div className="flex items-center justify-center gap-2 mt-2 text-sm opacity-90">
              <Globe className="w-4 h-4" />
              <span>{countryName}</span>
              {isLoading && <span className="text-xs">(wird erkannt...)</span>}
            </div>
            
            <div className="text-4xl font-bold mt-4">
              {isLoading ? (
                <div className="animate-pulse">...</div>
              ) : (
                <>
                  {pricing[currency].symbol} {pricing[currency].amount} 
                  <span className="text-lg font-normal">/Monat</span>
                </>
              )}
            </div>
            
          </CardHeader>
          <CardContent className="p-8">
            <ul className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span className="text-left">{feature}</span>
                </li>
              ))}
            </ul>
            
            <a href="/register?fuer=angehoeriger">
              <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 text-lg rounded-full">
                14 Tage kostenlos starten
              </Button>
            </a>
            
            <p className="text-sm text-gray-600 mt-4">
              Jederzeit kündbar • Keine Kreditkarte nötig
            </p>
            
            {/* Currency switcher for manual override */}
            {!isLoading && (
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-xs text-gray-500 mb-2">Andere Währung wählen:</p>
                <div className="flex gap-2 justify-center">
                  <button
                    onClick={() => setCurrency('CHF')}
                    className={`px-3 py-1 text-xs rounded-full border ${
                      currency === 'CHF' 
                        ? 'bg-blue-600 text-white border-blue-600' 
                        : 'bg-white text-gray-600 border-gray-300 hover:border-blue-300'
                    }`}
                  >
                    CHF
                  </button>
                  <button
                    onClick={() => setCurrency('EUR')}
                    className={`px-3 py-1 text-xs rounded-full border ${
                      currency === 'EUR' 
                        ? 'bg-blue-600 text-white border-blue-600' 
                        : 'bg-white text-gray-600 border-gray-300 hover:border-blue-300'
                    }`}
                  >
                    EUR
                  </button>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
        
      </div>
    </section>
  );
};

export default PricingSection;
